import React from 'react'
import "./banner.css"

function Banner() {
  return (
    <div>
        <div className='banner-container'>
                <img className ="banner-image"
                src='https://share.cdn.viber.com/pg_download?id=0-04-03-a1edcb460c1b3240426b622cdfa3b372bdcfd1b1e46374ed5474907c33be7c5f&filetype=jpg&type=icon' alt='' />
                
                <div className='banner-title'>
                    <h1>Every Friday!</h1>
                    <div className='banner-text'>
                        <h3>Collect & Save</h3><hr />
                        <h3>Up to 10% off</h3><hr />
                        <h3>Max Rs.500</h3>
                    </div>

                </div>
               <img className='atm-card' src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ74isF_hBHfIUq-pJVjyb-H2GdEdz3fSY-Bw&usqp=CAU' alt='' />
              <p>Shop & Redeem</p>
        </div>
    </div>
  )
}

export default Banner